import { render, staticRenderFns } from "./ColorSeriesPicker.vue?vue&type=template&id=57546b8e&scoped=true&"
import script from "./ColorSeriesPicker.vue?vue&type=script&lang=js&"
export * from "./ColorSeriesPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorSeriesPicker.vue?vue&type=style&index=0&id=57546b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57546b8e",
  null
  
)

export default component.exports